import { useState } from 'react';
import { useAnonymousUpgradePrompt } from '../hooks/useAnonymousUpgradePrompt';
import AuthModal from './AuthModal';
import './AnonUpgradeBadge.css';

// The persistent, always-visible escape hatch for a guest session — present
// on every screen (mounted once from App.js, outside the Home/Lobby/
// Tournament switch) regardless of whether the post-tournament AuthModal has
// fired, been dismissed, or hasn't triggered yet. This is the primary safety
// net for someone who dismissed that prompt and changes their mind later, or
// who wants to sign up before finishing a tournament.
function AnonUpgradeBadge() {
  const { isAnonymous } = useAnonymousUpgradePrompt();
  const [modalVariant, setModalVariant] = useState(null); // null | 'nav-prompt' | 'sign-in'

  if (!isAnonymous) return null;

  return (
    <>
      <div className="anon-upgrade-badge">
        <button className="anon-upgrade-badge-save" onClick={() => setModalVariant('nav-prompt')}>
          🔐 Save progress
        </button>
        <button className="anon-upgrade-badge-signin" onClick={() => setModalVariant('sign-in')}>
          Sign in
        </button>
      </div>
      {modalVariant && (
        <AuthModal
          variant={modalVariant}
          onClose={() => setModalVariant(null)}
          onAuthenticated={() => setModalVariant(null)}
        />
      )}
    </>
  );
}

export default AnonUpgradeBadge;
